import React, { useEffect } from "react";
import Footer from "./Footer";
import img from "../../assets/pic/kkkkkk.png";
import { LayoutForLandingPage } from "./Home";
const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="flex flex-col justify-center gap-4 mt-20">
      <h2 className="text-[48px] font-semibold flex justify-center mt-8 items-center">
        About <span className="text-[#F66] ml-2">Us</span>
      </h2>
      <LayoutForLandingPage>
        <div className="max-w-6xl mx-auto flex flex-col gap-6 p-6 bg-white rounded-lg shadow-md">
          <div className="flex items-center justify-center">
            <img
              className="flex justify-center items-center rounded-md border-2 p-2"
              src={img}
              alt=""
              width={700}
            ></img>
          </div>
          <p className="text-[21px] leading-relaxed">
            In today's busy world, it's easy to let life get in the way of
            staying connected with the people we love. Between juggling work,
            family, and everything else, it can be tough to find the time to
            show our loved ones how much we care.{" "}
          </p>{" "}
          <p className="text-[21px] leading-relaxed">
            That's where we come in. We're here to help you create personalized
            greeting cards that express your love and appreciation in a way
            that's both meaningful and convenient. Our platform makes it easy to
            pick beautiful cards that are tailored to the recipient, so you can
            be sure they'll feel loved and cherished.{" "}
          </p>{" "}
          <p className="text-[21px] leading-relaxed">
            We help you create personalized cards that express your love,
            without adding to your to-do list. Whether it's your Grandma, your
            Grandkids, or your favorite niece, our platform will help you:
          </p>{" "}
          <ul className="list-inside">
            <li className="ml-4 mb-4">
              <p className="text-lg">
                <span className="font-semibold">
                  1. Craft the perfect message:
                </span>{" "}
                Say goodbye to writer's block! We'll suggest personalized
                messages based on your recipient's personality traits.
              </p>{" "}
            </li>
            <li className="ml-4 mb-4">
              {" "}
              <p className="text-lg">
                <span className="font-semibold">
                  2. Never miss their special occasion:
                </span>{" "}
                We'll send you timely reminders, so you never forget an
                important occasion.
              </p>{" "}
            </li>
            <li className="ml-4 ">
              {" "}
              <p className="text-lg">
                <span className="font-semibold">
                  3. Send cards without lifting a finger:
                </span>{" "}
                We'll print, address, and mail your cards directly to your loved
                ones.
              </p>{" "}
            </li>
          </ul>{" "}
          <p className="text-[21px] leading-relaxed">
            Let us help you reconnect with the people who matter most, one
            heartfelt greeting card at a time.
          </p>
        </div>
      </LayoutForLandingPage>
      <Footer />
    </div>
  );
};

export default AboutUs;
